import React from 'react';
import PropTypes from 'prop-types';
import AccessIcon from 'assets/icons/AccessIcon';
import ActionButton from 'components/button/ActionButton';
import translate from 'components/hoc/translate';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reservationSessionStart, reservationSessionStop } from 'store/actions/reservations/session/reservationSessions';
import { fetchAccessPoints } from 'store/actions/accessPoints/fetchAccessPoints';
import ReservationSessionStartModal from './ReservationSessionStartModal';
import { fetchAccessPointAccessMethods } from 'store/actions/accessPoints/access-methods/fetch/fetchAccessPointAccessMethods';

class ReservationSessionContainer extends React.Component {
    constructor(props) {
        super(props);

        const {
            canEndSession,
            canStartSession,
        } = props;

        // Build the current session.
        this.sessionStart = 'start';
        this.sessionEnd = 'end';

        let session = null;

        if (canStartSession) {
            session = this.sessionStart;
        } else if (canEndSession) {
            session = this.sessionEnd;
        }

        // Define the phases.
        this.options = 'options';
        this.loading = 'loading';
        this.result = 'result';

        this.state = {
            currentSession: session,
            phase: this.options,
            showModal: false,
            message: null,
        };
    }

    componentDidMount() {
        const { product, dispatchFetchAccessPoints } = this.props;

        dispatchFetchAccessPoints(product.id);
    }

    closeModal = () => {
        this.setState({
            message: null,
            phase: this.options,
            showModal: false,
        });
    }

    handleSubmit = (formData) => {
        const {
            canStartSession,
            dispatchSessionStart,
            dispatchSessionStop,
            id,
            translate,
        } = this.props;

        const {
            currentSession,
        } = this.state;

        const {
            access_points_access_method_id,
            execute_access,
            force,
        } = formData;

        const params = {
            ...(access_points_access_method_id && { access_points_access_method_id }),
            execute_access,
            force,
        };

        /*
         * If we force end a session we need to have the asset status to change to. For this iteration of
         * DASH it'll always be available, picking it will be for DASH-NEXT
         */
        if (force) {
            params.asset_status = 'available';
        }

        const onError = (err) => {
            if (err.response.message === 'asset-not-usable') {
                return this.setState({
                    message: err.response.message,
                    failures: err.response.errors,
                    phase: this.result,
                });
            }

            return this.setState({
                message: translate(`resources.reservations.session.modal.callback.${ currentSession }.error`),
                phase: this.result,
            });
        };

        const onSuccess = (response) => {
            if (response.status === 'failed') {
                return onError();
            }

            return this.setState({
                message: translate(`resources.reservations.session.modal.callback.${ currentSession }.success`),
                phase: this.result,
            });
        };

        const dispatchAction = canStartSession ? dispatchSessionStart : dispatchSessionStop;

        return new Promise(() => {
            dispatchAction({
                id,
                params,
                onError: onError,
                onSuccess: onSuccess,
            });
        });
    }

    openModal = () => {
        this.setState({
            showModal: true,
        });
    }

    onSelectAccessPoint = (id) => {
        const { dispatchFetchAccessPointAccessMethods } = this.props;

        if (id) {
            dispatchFetchAccessPointAccessMethods(id);
        }
    };

    render() {
        const {
            translate,
        } = this.props;

        const {
            currentSession,
            message,
            phase,
            showModal,
            failures,
        } = this.state;

        // If the currentSession is empty we will return nothing.
        if (!currentSession) {
            return null;
        }

        return (
            <div>
                <ActionButton
                    disabled={ false }
                    icon={ <AccessIcon /> }
                    onClick={ this.openModal }
                    title={ translate(`resources.reservations.session.button.${ currentSession }`) }
                />

                {
                    showModal &&
                    <ReservationSessionStartModal
                        currentSession={ currentSession }
                        onHandleSubmit={ this.handleSubmit }
                        onCloseModal={ this.closeModal }
                        phase={ phase }
                        onSelectAccessPoint={ this.onSelectAccessPoint }
                        message={ message }
                        failures={ failures }
                    />
                }
            </div>
        );
    }
}

ReservationSessionContainer.propTypes = {
    canEndSession: PropTypes.bool.isRequired,
    canStartSession: PropTypes.bool.isRequired,
    dispatchFetchAccessPoints: PropTypes.func.isRequired,
    dispatchFetchAccessPointAccessMethods: PropTypes.func.isRequired,
    dispatchSessionStart: PropTypes.func,
    dispatchSessionStop: PropTypes.func,
    id: PropTypes.number.isRequired,
    product: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchFetchAccessPoints: (productId) => {
            dispatch(fetchAccessPoints({
                product_id: productId,
            }));
        },
        dispatchFetchAccessPointAccessMethods: (access_point_id) => {
            dispatch(fetchAccessPointAccessMethods({
                access_point_id,
            }));
        },
        dispatchSessionStart: (payload) => {
            dispatch(reservationSessionStart(payload));

        },
        dispatchSessionStop: (payload) => {
            dispatch(reservationSessionStop(payload));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps
    ),
);

export default enhance(ReservationSessionContainer);



// WEBPACK FOOTER //
// ./src/pages/reservations/show/session/ReservationSessionContainer.js